import { createContext, useContext, useState } from "react";
import { getLocalStorage } from "../helpers/browserStorage";

const AppContext = createContext();

export const useApp = () => {
  return useContext(AppContext);
};

function AppProvider({ children }) {
  const [organizationId, setOrganizationId] = useState(
    getLocalStorage("organizationId")
  );
  const [isOwner, setIsOwner] = useState(false);

  const [pageId, setPageId] = useState(getLocalStorage("pageId"));

  const [pages, setPages] = useState([]);

  return (
    <AppContext.Provider
      value={{
        organizationId,
        setOrganizationId,
        isOwner,
        setIsOwner,
        pageId,
        setPageId,
        pages,
        setPages,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export default AppProvider;
